'use client';

import _ReactPlayer from 'react-player';

var ReactPlayer = _ReactPlayer;
var EType;
(function (EType) {
    EType["LARGE"] = "large";
    EType["MEDIUM"] = "medium";
    EType["SMALL"] = "small";
})(EType || (EType = {}));

export { EType, ReactPlayer };
//# sourceMappingURL=types.js.map
